<template>
  <div class="cu-prow">
    <div class="cu-pname">{{ name }}</div>
    <div class="cu-track"
         role="progressbar"
         :aria-valuenow="queued ? null : percent"
         aria-valuemin="0"
         aria-valuemax="100">
      <div class="cu-fill"
           :class="{ '--q': queued }"
           :style="{ width: queued ? '100%' : percent + '%' }"></div>
    </div>
    <div class="cu-fig">{{ figure }}</div>
  </div>
</template>

<script>
const minutes = (seconds) => Math.max(1, Math.round(seconds / 60));
const num = (n) => Number(n).toLocaleString("en-US");

// One Page's row in the "ดึงแชทย้อนหลัง 30 วัน" indicator. `item` is an entry of sync[] in
// GET /api/broadcast/customers/summary: {pageId, state, percent, etaSeconds, contactsSoFar,
// estimatedContacts, queuePosition, queueEtaSeconds}. `name` is the Page's name (the sync entry has none).
// A Page waiting in the queue shows the striped pulsing bar; a running one fills to `percent`.
export default {
  name: "BcProgress",
  props: {
    name: { type: String, required: true },
    item: { type: Object, required: true },
  },
  computed: {
    queued() {
      return this.item.queuePosition != null;
    },
    percent() {
      return Math.max(0, Math.min(100, Math.round(Number(this.item.percent) || 0)));
    },
    figure() {
      const it = this.item;
      if (this.queued) {
        return it.queueEtaSeconds != null
          ? this.$t("broadcast.progress.queued_eta", { pos: num(it.queuePosition), min: num(minutes(it.queueEtaSeconds)) })
          : this.$t("broadcast.progress.queued", { pos: num(it.queuePosition) });
      }
      const got = num(it.contactsSoFar || 0);
      const eta = it.etaSeconds != null ? num(minutes(it.etaSeconds)) : null;
      if (it.estimatedContacts != null) {
        const vars = { got, total: num(it.estimatedContacts), min: eta };
        return this.$t(eta ? "broadcast.progress.got_of_eta" : "broadcast.progress.got_of", vars);
      }
      return this.$t(eta ? "broadcast.progress.got_eta" : "broadcast.progress.got", { got, min: eta });
    },
  },
};
</script>

<style lang="scss" scoped>
.cu-prow {
  padding: 0.35rem 0 0.6rem;
}

.cu-pname {
  font-size: 0.9375rem;
  color: #333;
  font-weight: 700;
}

.cu-track {
  height: 6px;
  border-radius: 3px;
  background: #dcdcdc;
  overflow: hidden;
  margin: 0.35rem 0 0.25rem;
}

.cu-fill {
  height: 100%;
  border-radius: 3px;
  background: $brand-blue-mid;
  transition: width 0.4s ease;

  &.--q {
    background: repeating-linear-gradient(45deg, rgba($brand-blue-mid, 0.45) 0 6px, rgba($brand-blue-mid, 0.2) 6px 12px);
    animation: cu-pulse 1.6s ease-in-out infinite;
  }
}

.cu-fig {
  text-align: right;
  font-size: 0.8125rem;
  color: #555;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-variant-numeric: tabular-nums;
}

@keyframes cu-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cu-fill {
    transition: none;

    &.--q {
      animation: none;
    }
  }
}

body.--dark {
  .cu-pname {
    color: #e6e6e6;
  }

  .cu-track {
    background: #666;
  }

  .cu-fill {
    background: #5fa8e0;

    &.--q {
      background: repeating-linear-gradient(45deg, rgba(95, 168, 224, 0.55) 0 6px, rgba(95, 168, 224, 0.25) 6px 12px);
    }
  }

  .cu-fig {
    color: #c4c4c4;
  }
}
</style>

